module.exports = __webpack_public_path__ + "img/skredfaresoner.4bae6692.jpg";